import { Component, OnInit, Input, ViewChild,ChangeDetectorRef  } from '@angular/core';
import { Route, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AlertService } from 'src/app/services/alerts.service';
import { ConversationService } from 'src/app/services/conversation.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'comp-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
})
export class AlertComponent implements OnInit {
    // Alerts
    @Input() alerts: any = [];
    filteredAlerts: any = [];
    user: any;
    showOpportunities: boolean = true;
    showLeases: boolean = true;
    opportunityCount: number = 0;
    leaseCount: number = 0;

    constructor(
        private changeDetector: ChangeDetectorRef,
        private alertService: AlertService,
        private userService: UserService,
        private router: Router,
        private modalCtrl: ModalController,
        private convoService: ConversationService
    ) {
        this.onAlertClick = this.onAlertClick.bind(this);
        this.onViewAllClick = this.onViewAllClick.bind(this);
    }

    ngOnInit(): void {
        this.user = JSON.parse(localStorage.getItem('user')) || {};
        //console.log(this.user);
        this.getAlerts();

        
    }

    // Alerts
    getAlerts(): void {
        this.alertService.getAlerts().subscribe((resp) => {
            this.alerts = resp['alerts'];
            this.updateCounts();
            this.filterAlerts();
            this.changeDetector.detectChanges();
            //console.log(this.alerts);
        });
        
    }

    updateCounts(): void {
        this.opportunityCount = this.alerts.filter(alert => !alert.conversation.custom || alert.conversation.custom.module === 1).length;
        this.leaseCount = this.alerts.filter(alert => alert.conversation.custom && alert.conversation.custom.module === 2).length;
    }

    filterAlerts(): void {
        this.filteredAlerts = this.alerts.filter(alert => {
            if (this.showOpportunities && (!alert.conversation.custom || alert.conversation.custom.module === 1)) {
                return true;
            }
            if (this.showLeases && alert.conversation.custom && alert.conversation.custom.module === 2) {
                return true;
            }
            return false;
        });
    }

    // Alert Click
    async onAlertClick(alert): Promise<void> {
        //console.log('Alert clicked:', alert);
    
        const id = parseInt(alert.path.split('?id=')[1], 10); // Convert to number
        //console.log('Extracted ID:', id);
    
        try {
            // Wait for the timestamp update to finish
            await this.updateConversationTimestamp(id);
    
            // Wait for the alert status update to finish
            await this.setAlertStatus(alert.id);
    
            // Dismiss the modal after all updates are completed
            this.modalCtrl.dismiss();
    
            // Emit the selected conversation ID
            this.convoService.emitActiveConversation(id);
        } catch (error) {
            console.error('Error handling alert click:', error);
        }
    }

    updateConversationTimestamp(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            this.alertService.updateConversationTimestamp(id).subscribe(
                () => resolve(),
                (error) => reject(error)
            );
        });
    }
    
    setAlertStatus(alertId: number): Promise<void> {
        return new Promise((resolve, reject) => {
            this.alertService.setAlertStatus(alertId).subscribe(
                () => resolve(),
                (error) => reject(error)
            );
        });
    }
    // onAlertClick(alert): void {
    //     console.log('Alert clicked:', alert);

    //     let id = alert.path.split('?id=')

    //     console.log('Extracted ID:', id[1]);

    //     this.alertService.setAlertStatus(alert.id).subscribe((resp) => {
    //         // Dismiss Modal
    //         this.modalCtrl.dismiss();

    //         // Load Alert
    //         this.router.navigate(['redirect'], { 
    //             queryParams : { id: id[1], storeChange: alert.dealer_id}
    //         });

    //     });
    // }

    onViewAllClick(): void {
        this.modalCtrl.dismiss();

        this.router.navigate(['alerts']);
    }
}